var _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path3, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconObservatory = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 80,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3691 32C21.5353 32 22.9156 30.6815 22.9156 27.5C22.9156 30.6815 24.2864 32 27.4622 32C24.2864 32 22.9156 33.3567 22.9156 36.5C22.9156 33.3567 21.5353 32 18.3691 32Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.496 60C131.662 60 133.043 58.6815 133.043 55.5C133.043 58.6815 134.413 60 137.589 60C134.413 60 133.043 61.3567 133.043 64.5C133.043 61.3567 131.662 60 128.496 60Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.54,
    cy: 11.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.912,
    cy: 29.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1878,
    cy: 14.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 34.0725,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 37.2347,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947469,
    cy: 21.678,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 57.6087,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26011,
    cy: 68.1656,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8437 41.1404C89.8437 37.6595 88.4609 34.3211 85.9995 31.8597C83.5381 29.3982 80.1997 28.0154 76.7187 28.0154M76.7187 28.0154C73.2378 28.0154 69.8994 29.3982 67.438 31.8597C64.9766 34.3211 63.5937 37.6595 63.5937 41.1404M76.7187 28.0154V23.6251C76.7215 23.3266 76.7909 23.0324 76.9219 22.7641C77.0528 22.4958 77.242 22.2601 77.4756 22.0742C77.9729 21.678 78.6068 21.4948 79.2387 21.5645C83.8459 21.926 88.1985 23.8231 91.5995 26.952C95.0005 30.0809 97.2531 34.2606 97.9966 38.8217C98.0321 39.1163 98.0006 39.4151 97.9043 39.6958C97.8081 39.9765 97.6497 40.2318 97.4409 40.4426C97.2208 40.6652 96.9584 40.8416 96.6691 40.9614C96.3799 41.0812 96.0696 41.1421 95.7566 41.1404H91.4844M88.6953 24.7517L92.8603 20.5473L99.005 26.7489L94.9734 30.8176M55.3906 64.1092H98.0469M60.8594 41.1404H92.5781C93.1583 41.1404 93.7147 41.3709 94.1249 41.7811C94.5352 42.1914 94.7656 42.7478 94.7656 43.3279V64.1092H58.6719V43.3279C58.6719 42.7478 58.9023 42.1914 59.3126 41.7811C59.7228 41.3709 60.2792 41.1404 60.8594 41.1404ZM96.8591 24.5811L94.9406 22.6561C93.9788 21.6852 93.4392 20.3739 93.4392 19.0073C93.4392 17.6407 93.9788 16.3294 94.9406 15.3586L95.0128 15.2864C95.1331 15.1643 95.2765 15.0673 95.4346 15.0011C95.5927 14.935 95.7624 14.9009 95.9338 14.9009C96.1051 14.9009 96.2748 14.935 96.4329 15.0011C96.591 15.0673 96.7344 15.1643 96.8547 15.2864L104.227 22.7239C104.472 22.9716 104.609 23.3061 104.609 23.6546C104.609 24.0032 104.472 24.3377 104.227 24.5854C103.744 25.0719 103.17 25.458 102.538 25.7213C101.905 25.9847 101.227 26.12 100.542 26.1196C99.8568 26.1192 99.1786 25.9831 98.5465 25.719C97.9143 25.4549 97.3408 25.0681 96.8591 24.5811ZM72.8906 49.3436H80.5469C80.837 49.3436 81.1152 49.4588 81.3203 49.6639C81.5254 49.869 81.6406 50.1472 81.6406 50.4373V64.1092H71.7969V50.4373C71.7969 50.1472 71.9121 49.869 72.1172 49.6639C72.3223 49.4588 72.6005 49.3436 72.8906 49.3436Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 80,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 80",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.3691 32C21.5353 32 22.9156 30.6815 22.9156 27.5C22.9156 30.6815 24.2864 32 27.4622 32C24.2864 32 22.9156 33.3567 22.9156 36.5C22.9156 33.3567 21.5353 32 18.3691 32Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.496 60C131.662 60 133.043 58.6815 133.043 55.5C133.043 58.6815 134.413 60 137.589 60C134.413 60 133.043 61.3567 133.043 64.5C133.043 61.3567 131.662 60 128.496 60Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.54,
    cy: 11.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.912,
    cy: 29.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1878,
    cy: 14.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 34.0725,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 37.2347,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947469,
    cy: 21.678,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 57.6087,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26011,
    cy: 68.1656,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.8437 41.1404C89.8437 37.6595 88.4609 34.3211 85.9995 31.8597C83.5381 29.3982 80.1997 28.0154 76.7187 28.0154M76.7187 28.0154C73.2378 28.0154 69.8994 29.3982 67.438 31.8597C64.9766 34.3211 63.5937 37.6595 63.5937 41.1404M76.7187 28.0154V23.6251C76.7215 23.3266 76.7909 23.0324 76.9219 22.7641C77.0528 22.4958 77.242 22.2601 77.4756 22.0742C77.9729 21.678 78.6068 21.4948 79.2387 21.5645C83.8459 21.926 88.1985 23.8231 91.5995 26.952C95.0005 30.0809 97.2531 34.2606 97.9966 38.8217C98.0321 39.1163 98.0006 39.4151 97.9043 39.6958C97.8081 39.9765 97.6497 40.2318 97.4409 40.4426C97.2208 40.6652 96.9584 40.8416 96.6691 40.9614C96.3799 41.0812 96.0696 41.1421 95.7566 41.1404H91.4844M88.6953 24.7517L92.8603 20.5473L99.005 26.7489L94.9734 30.8176M55.3906 64.1092H98.0469M60.8594 41.1404H92.5781C93.1583 41.1404 93.7147 41.3709 94.1249 41.7811C94.5352 42.1914 94.7656 42.7478 94.7656 43.3279V64.1092H58.6719V43.3279C58.6719 42.7478 58.9023 42.1914 59.3126 41.7811C59.7228 41.3709 60.2792 41.1404 60.8594 41.1404ZM96.8591 24.5811L94.9406 22.6561C93.9788 21.6852 93.4392 20.3739 93.4392 19.0073C93.4392 17.6407 93.9788 16.3294 94.9406 15.3586L95.0128 15.2864C95.1331 15.1643 95.2765 15.0673 95.4346 15.0011C95.5927 14.935 95.7624 14.9009 95.9338 14.9009C96.1051 14.9009 96.2748 14.935 96.4329 15.0011C96.591 15.0673 96.7344 15.1643 96.8547 15.2864L104.227 22.7239C104.472 22.9716 104.609 23.3061 104.609 23.6546C104.609 24.0032 104.472 24.3377 104.227 24.5854C103.744 25.0719 103.17 25.458 102.538 25.7213C101.905 25.9847 101.227 26.12 100.542 26.1196C99.8568 26.1192 99.1786 25.9831 98.5465 25.719C97.9143 25.4549 97.3408 25.0681 96.8591 24.5811ZM72.8906 49.3436H80.5469C80.837 49.3436 81.1152 49.4588 81.3203 49.6639C81.5254 49.869 81.6406 50.1472 81.6406 50.4373V64.1092H71.7969V50.4373C71.7969 50.1472 71.9121 49.869 72.1172 49.6639C72.3223 49.4588 72.6005 49.3436 72.8906 49.3436Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
});
export default SvgIconObservatory;
export const raw = __webpack_public_path__ + "static/media/icon-observatory.64dc7944d8c68915d963f45014765673.svg";